import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useSanityQuery } from '../../hooks/useSanityQuery';

const QUERY = `*[_type == "siteSettings"][0]{
  email, phone, taxId, address, footerDescription, copyrightText, socialLinks
}`;

const DEFAULTS = {
  email: 'info@uhfrelief.org',
  phone: '(313) 332-4348',
  taxId: '84-3581349',
  address: '14584 Southfield Rd Suite 200, Allen Park, MI 48101',
  footerDescription: 'We work to create a world where individuals have access to basic human needs and communities are empowered.',
  copyrightText: '© Copyrights 2023 UHF All rights reserved.',
  socialLinks: [
    { platform: 'facebook',  url: 'https://www.facebook.com/UHFRelief/' },
    { platform: 'twitter',   url: 'https://twitter.com/uhfrelief' },
    { platform: 'instagram', url: 'https://www.instagram.com/uhfrelief/?hl=en' },
    { platform: 'linktree',  url: 'https://linktr.ee/uhfrelief' },
  ],
};

const ICON_MAP = {
  facebook: 'fab fa-facebook-f',
  twitter: 'fab fa-twitter',
  instagram: 'fab fa-instagram',
  linktree: 'fa fa-link',
  youtube: 'fab fa-youtube',
};

export default function Footer() {
  const { data } = useSanityQuery(QUERY);

  const email           = data?.email           || DEFAULTS.email;
  const phone           = data?.phone           || DEFAULTS.phone;
  const taxId           = data?.taxId           || DEFAULTS.taxId;
  const address         = data?.address         || DEFAULTS.address;
  const footerDescription = data?.footerDescription || DEFAULTS.footerDescription;
  const copyrightText   = data?.copyrightText   || DEFAULTS.copyrightText;
  const socialLinks     = data?.socialLinks     || DEFAULTS.socialLinks;

  return (
    <footer className='container-fluid black_more'>
      <div className='bg-footer'>
        <img src='/img/footer-img.jpg' alt='bg-footer'/>
      </div>
      <div className='row m-10-hor'>
        <div className='col-md-4'>
          <div className='footer-col'>
            <div className='heading'>
              <h2 className='font-weight-bold'>About Us</h2>
            </div>
            <div className='content'>
              <p>{footerDescription}</p>
            </div>
            <div className="contact-info">
              <div className='info-item'>
                <i className="fas fa-envelope"></i>
                <a style={{ textDecoration: 'none', color: '#c8b16f' }} href={`mailto:${email}`}>
                  {email}
                </a>
              </div>
              <div className='info-item'>
                <i className="fas fa-phone-alt"></i>
                <a style={{ textDecoration: 'none', color: '#c8b16f' }} href={`tel:${phone.replace(/\D/g, '')}`}>
                  {phone}
                </a>
              </div>
              <div className='info-item'>
                <i className="fas fa-id-card"></i>
                TAX ID: {taxId}
              </div>
              <div className='info-item'>
                <i className="fas fa-map-marker-alt"></i>
                {address}
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-2'>
          <div className='footer-col'>
            <div className='heading'>
              <h2 className='font-weight-bold'>Useful Links</h2>
            </div>
            <div className='content'>
              <div className='link'><a href="/donate">Donate</a></div>
              <div className='link'><a href="/contact">Contact Us</a></div>
            </div>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='footer-col'>
            <div className='heading'>
              <h2 className='font-weight-bold'>Follow Us</h2>
            </div>
            <div className='content social-icons'>
              {socialLinks.map((link, i) => (
                <a key={i} href={link.url} target="_blank" rel="noopener noreferrer">
                  <div className='socialicon'>
                    <i className={ICON_MAP[link.platform] || 'fa fa-link'}></i>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='subfooter'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
            <div className='content'>{copyrightText}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
